export default '5.7.0';


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/react-instantsearch-core/dist/es/core/version.js
// module id = 716
// module chunks = 0 1 2 3 4 5 6 7 8